import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

const getDayjs = (date) => {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const timeZone = 'America/Santo_Domingo';
  return date ? dayjs.utc(date).tz(timeZone) : dayjs.utc().tz(timeZone)
}


export const formatoFecha = (fechaString) => {
  const fechaActual = getDayjs();

  // Convertir la fecha proporcionada a un objeto de Day.js
  const fecha = getDayjs(fechaString);

  // Calcular la diferencia en minutos, horas y días
  const minutos = Math.abs(fecha.diff(fechaActual, 'minute'));
  const horas = Math.abs(fecha.diff(fechaActual, 'hour'));
  const dias = Math.abs(fecha.diff(fechaActual, 'day'));

  // Calcular los minutos restantes después de calcular las horas
  const minutosRestantes = minutos - horas * 60;

  // Devolver el formato apropiado dependiendo de la diferencia
  if (minutos < 60) {
    return `Hace ${minutos} minutos`;
  }
  if (horas < 24) {
    return `Hace ${horas} horas y ${minutosRestantes} minutos`;
  }
  if (dias < 3) {
    return `Hace ${dias} días, ${horas} horas y ${minutosRestantes} minutos`;
  }

  // Si han pasado más de 3 días, devolver la fecha tal cual
  return fecha.format('DD/MM/YYYY hh:mm A');
}


export const formatoFechaAmFm = (fechaString) => {
  const fecha = getDayjs(fechaString);
  return fecha.format('DD/MM/YYYY hh:mm A');
}


export const formatoFechaTable = (fechaString) => {
  const fecha = getDayjs(fechaString);
  return fecha.format('DD/MM/YYYY');
}



export default getDayjs;
